import { PermissionEnum, apiAbortController } from '@ui/src';
import api from '../../api/api';

export interface PermissionResponse {
  permissions: PermissionEnum[];
}

export const notificationCenterDictionariesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getNotificationCenterPermissions: build.query<
      { data: PermissionResponse },
      void
    >({
      query: () => ({
        url: '/v1/employees/whoami',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getNotificationCenterWhitelabel: build.query<
      {
        data: {
          data: {
            value: Record<string, string>;
          };
        };
      },
      void
    >({
      query: () => ({
        url: '/v1/settings/whitelabel',
      }),
    }),
  }),
});

export const {
  useLazyGetNotificationCenterPermissionsQuery,
  useLazyGetNotificationCenterWhitelabelQuery,
} = notificationCenterDictionariesApi;

export const {
  endpoints: {
    getNotificationCenterPermissions,
    getNotificationCenterWhitelabel,
  },
} = notificationCenterDictionariesApi;
